/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  ON_PROGRESS_DATA,
  ON_GSTR_SUMMARY,
  ON_GSTR_SUMMARY_AMD,
  SET_NIL_DATA,
  SET_DOC_ISSUE_DATA,
  LOADER_STATUS,
  EXCELL_TABLE_STATUS,
  SET_FILE_DATA,
  SET_OTP_BOX,
  SET_DIFF_TABLE,
  OTP_INVALID,
  SET_SUMMARY_TABLE,
  SET_SUMMARY_TABLE_DATA,
  SET_DIFF_TABLE_DATA,
  SET_HEADING,
  SET_PLEASEWAIT,
  SET_TOTAL_RECORD,
  ERROR_MODAL,
  SET_MASTER_FILE_DATA,
  GET_ITEM,
  TOTAL_ITEM_RECORDS,
  TXN_RECORD,
  ITEMS_TABLE_STATUS,
  SET_MATCH_BUTTON_STATUS,
  PROFILE_INFO,
  SET_AUTO_POPULATED_HISTORY,
  SET_RECO_HISTORY,
  SET_HSN_DATA
} from "./constants";

// The initial state of the App
export const initialState = {
  progressData: [],
  loaderStatus: false,
  activeExcellTable: false,
  fileData: [],
  masterFileData: [],
  isOtpActive: false,
  isDiffActive: false,
  isOtpInvalid: false,
  isSummaryActive: false,
  summaryTableData: [],
  diffTableData: [],
  heading: "Uploaded Data",
  isWait: false,
  totalRecord: "",
  isErrorModal: false,
  matchStr: "",
  totalCount: 0,
  itemData: [],
  totalItemRecord: "",
  activeItemsTable: false,
  matchButtonStatus: false,
  summaryData: [],
  summaryAmdData:[],
  nilData: [],
  docData: [],
  profileData: [],
  autoPopulatedHistory: [],
  recoHistory:[],
  hsnData:[]
};

/* eslint-disable default-case, no-param-reassign */
const uploadedDataReducer = (state = initialState, action) =>{
    switch (action.type) {
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
      case ON_GSTR_SUMMARY:
        return {
          ...state,
          summaryData:action.summaryData
        }
      case ON_GSTR_SUMMARY_AMD:
        return {
          ...state,
          summaryAmdData:action.summaryAmdData
        }
      case SET_NIL_DATA:
        return {
          ...state,
          nilData:action.nilData
        }
      case SET_HSN_DATA:
        return {
          ...state,
          hsnData:action.hsnData
        }
      case SET_DOC_ISSUE_DATA:
        return {
          ...state,
          docData:action.docData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case EXCELL_TABLE_STATUS:
        return {
          ...state,
          activeExcellTable:action.activeExcellTable
        }
      case SET_FILE_DATA:
        return {
          ...state,
          fileData:action.fileData
        }
      case SET_MASTER_FILE_DATA:
        return {
          ...state,
          masterFileData:action.masterFileData
        }
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.status,
        }
      case SET_DIFF_TABLE:
        return {
          ...state,
          isDiffActive:action.status,
        }
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.status,
        }
      case SET_SUMMARY_TABLE:
        return {
          ...state,
          isSummaryActive:action.status,
        }
      case SET_SUMMARY_TABLE_DATA:
        return {
          ...state,
          summaryTableData:action.data,
          totalCount:action.totalCount
        }
      case SET_DIFF_TABLE_DATA:
        return {
          ...state,
          diffTableData:action.diffTableData
        }
      case SET_HEADING:
        return {
          ...state,
          heading:action.heading
        }
      case SET_PLEASEWAIT:
        return {
          ...state,
          isWait:action.isWait
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          totalRecord:action.totalRecord
        }
      case ERROR_MODAL:
        return {
          ...state,
          isErrorModal:action.isErrorModal
        }
      case "SET_MATCH_TYPE":
        return {
          ...state,
          matchStr:action.matchStr
        }
      case GET_ITEM:
        return {
          ...state,
          itemData:action.itemData
        }
      case TOTAL_ITEM_RECORDS:
        return {
          ...state,
          totalItemRecord:action.totalItemRecord
        }
      case ITEMS_TABLE_STATUS:
        return {
          ...state,
          activeItemsTable:action.activeItemsTable
        }
      case SET_MATCH_BUTTON_STATUS:
        return {
          ...state,
          matchButtonStatus:action.matchButtonStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_AUTO_POPULATED_HISTORY:
        return {
          ...state,
          autoPopulatedHistory:action.payload
        }
      case SET_RECO_HISTORY:
        return {
          ...state,
          recoHistory:action.payload
        }
      default:
        return state;
    }
  };

export default uploadedDataReducer;
